export const API_START = 'api/API_START';
export const API_END = 'api/API_END';
export const API_ERROR = 'api/API_ERROR';
export const API_SUCCESS = 'api/API_SUCCESS';
export const SET_QUERY = 'api/SET_QUERY';
export const API_SUBMIT_START = 'api/API_SUBMIT_START';
export const API_SUBMIT_END = 'api/API_SUBMIT_END';
export const TOGGLE_MODAL = 'api/TOGGLE_MODAL';
export const TOGGLE_FILTER = 'api/TOGGLE_FILTER';
export const SET_TAB = 'api/SET_TAB';
export const SET_REFRESH = 'api/SET_REFRESH';

export default {
	API_START,
	API_END,
	API_ERROR,
	API_SUCCESS,
	SET_QUERY,
	API_SUBMIT_START,
	API_SUBMIT_END,
	TOGGLE_MODAL,
	TOGGLE_FILTER,
	SET_TAB,
	SET_REFRESH,
};
